// Waits for an element to exist in the DOM, by trying n
// times in intervals of 1 second to target the element

export const waitForElementExists = async (query: string, step = 0) => {
  const TIMEOUT = 1000

  if (step === 60) {
    return false
  }

  const element = document.querySelector(query)

  if (!element) {
    await new Promise((resolve) => {
      setTimeout(resolve, TIMEOUT)
    })
    return waitForElementExists(query, step + 1)
  }

  return true
}
